import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import moment from 'moment';

import { redirect } from '../../../widgets/I18nLink';
import SearchForm from '../../../widgets/SearchForm';

import bgImage from '../../../images/lead-bg-2.webp';
import './LeadSection.css';

const handleSearchSubmit = (data) => redirect({
  pathname: '/search/',
  query: {
    bikeTypes: data.bikeTypes.join(','),
    country: data.country,
    pickUpCity: data.pickUpCity,
    dropOfCity: data.dropOfCity,
    returnAtSameCity: data.returnAtSameCity,
    begin: moment(data.beginDateTime).toISOString(),
    end: moment(data.endDateTime).toISOString(),
    age: data.age
  }
});

const LeadSection = ({
  t,
  h1,
  countries,
  bikeTypes,
  initialState,
  headerImage
}) => {
  const title = h1 || t('Rent a motorcycle, scooter or bicycle in any part of the world at the best prices');

  return (
    <div className="section home-lead-section">
      <div className="home-lead-section__bg">
        <img
          alt="Motorcycle and scooter rental"
          src={headerImage || bgImage}
          width={1200}
          height={800}
        />
      </div>

      <Grid className='home-lead-section__container'>
        <Row>
          <Col lg={4} md={5} sm={6}>
            <SearchForm
              className="lead-section"
              onSubmit={handleSearchSubmit}
              countries={countries}
              bikeTypes={bikeTypes}
              initialState={initialState}
            />
          </Col>

          <Col lg={7} lgOffset={1} md={7} sm={6}>
            <div className="advantages-container">
              <h1>{title}</h1>
              <ul className="advantages-list">
                <li>{t('Compare 942 rental companies')}</li>
                <li>{t('Best price guaranteed')}</li>
                <li>{t('Manage your booking online')}</li>
                <li>{t('Verified reviews')}</li>
                <li>{t('Free cancellation')}</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

LeadSection.propTypes = {
  h1: PropTypes.string,
  countries: PropTypes.array,
  bikeTypes: PropTypes.array,
  initialState: PropTypes.object,
  headerImage: PropTypes.string
};

export default translate(['translation'])(LeadSection);



// WEBPACK FOOTER //
// ./src/components/HomePage/LeadSection/LeadSection.js